import React from 'react';

export const OperatorsIcon = () => {
	return (
		<svg width="45" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M8.99942 16C13.3143 16 17 16.6983 17 19.4875C17 22.278 13.3376 23 8.99942 23C4.68457 23 1 22.303 1 19.5125C1 16.722 4.66119 16 8.99942 16Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M18 13C20.6966 13 23 13.5203 23 15.5988C23 16.9855 21.9823 17.6867 20.5002 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path fillRule="evenodd" clipRule="evenodd" d="M8.99943 11C6.22374 11 4 8.77512 4 5.99943C4 3.22488 6.22374 1 8.99943 1C11.7751 1 14 3.22488 14 5.99943C14 8.77512 11.7751 11 8.99943 11Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M19 9C21.2203 9 23 7.22009 23 4.99954C23 2.77991 21.2203 1 19 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</svg>

	);
};
